document.addEventListener("DOMContentLoaded", function() {
  const calendar = document.querySelector('.advent-calendar__calendar');
  const calendarActiveCTA = document.querySelector('.advent-calendar__calendar__box.active');
  const promo = document.querySelector('.advent-calendar__promo');
  const text = document.querySelector('.advent-calendar__text');
  const newsletter = document.querySelector('.advent-calendar__newsletter');
  const newsletterSignUp = newsletter.querySelector('form button.btn');
  const signupConfirm = newsletter.querySelector('button.sign-up-extra');

  const insideText = document.querySelector('.advent-calendar__offer__text');
  const wrongInsideText = document.querySelector('.advent-calendar__offer__text__in');
  const copyCode = insideText.querySelector('.code');
  const copyCodeBtn = insideText.querySelector('#copy-code');

  let allow = '';
  let selectedValue = '';

  if (sessionStorage.getItem('quizAllow')) {
    allow = sessionStorage.getItem('quizAllow');
  } else {
    allow = 'true';
  }

  if (newsletter) {
    if (localStorage.getItem("shownewsletter") == 'hide') {
      newsletter.classList.remove('active');
    }
  }

  if (signupConfirm && newsletterSignUp) {
    signupConfirm.addEventListener('click', () => {
      localStorage.setItem("shownewsletter", 'hide');
      newsletterSignUp.click();
      signupConfirm.style.display = 'none';
    });
  }

  if (calendar && calendarActiveCTA && promo) {
    calendarActiveCTA.addEventListener('click', () => {
      calendar.classList.remove('active');
      promo.classList.add('active');
      window.scrollTo({
        top: 250,
        behavior: "smooth"
      });

      if (text) {
        text.classList.remove('active');
      }

      if (newsletter) {
        newsletter.classList.remove('active');
      }
    });

    const answers = document.querySelector('.advent-calendar__answers');

    if (answers) {
      const correctAnswer = answers.dataset.aid;
      const checkboxes = answers.querySelectorAll('input[name="answer"]');

      const correctAnswerID = answers.dataset.lid;
      const newsletterIDField = answers.querySelector('.advent-calendar__answers__submit input[name="g"]');
      const incorretAnswerID = newsletterIDField.value;

      const failureMsg = answers.dataset.failure;
      const correctMsg = answers.dataset.correctmsg;
      const correctBtnUrl = answers.dataset.correctbtnurl;
      const correctBtnLbl = answers.dataset.correctbtnlbl;
      const wrongMsg = answers.dataset.wrongmsg;

      const extraConfirm = answers.querySelector('button.confirm-extra');
      const sendButton = answers.querySelector('.advent-calendar__answers__submit form button.btn');

      if (checkboxes.length && allow != 'false') {
        checkboxes.forEach(item => {
          item.addEventListener('change', () => {
            checkboxes.forEach(element => {
              element.checked = false;
            });
            item.checked = true;
            selectedValue = item.value;
            if (item.value == correctAnswer) {
              newsletterIDField.value = correctAnswerID;
            } else {
              newsletterIDField.value = incorretAnswerID;
            }
          });
        });
      } else {
        insideText.innerHTML = '<p>' + failureMsg + '</p>';
      }

      if (extraConfirm) {
        extraConfirm.addEventListener('click', () => {
          const userEmail = answers.querySelector('input[type="email"]').value;
          if (userEmail) { 
            if (selectedValue == '') {
              alert('Please select answer!');
            } else {
              if (selectedValue == correctAnswer) {
                setTimeout(() => {
                  sendButton.click();
                  setTimeout(() => {
                    insideText.innerHTML = '<p>' + correctMsg + '</p><p><a href="' + correctBtnUrl + '" class="btn btn--filled">' + correctBtnLbl + '</a>';
                    sessionStorage.setItem('quizAllow', false);
                  }, 1300);
                }, 200);
              } else {   
                setTimeout(() => {
                  wrongInsideText.innerHTML = '<p style="color: #cb0e0e;">Your answer is wrong</p><p style="color: #cb0e0e;">' + wrongMsg + '</p>';
                  const secondNewsletter = document.querySelector('.advent-calendar__offer__text__second');
                  secondNewsletter.style.display = 'block';
                  const emailInput = secondNewsletter.querySelector('input[type="email"]');
                  emailInput.value = userEmail;
                  sessionStorage.setItem('quizAllow', false);
                }, 2500);
              }
            }
          } else {
            alert('Please type your email!');
          }
        });
      }
    }

    if (copyCode && copyCodeBtn) {
      copyCodeBtn.addEventListener('click', () => {
        navigator.clipboard.writeText(copyCode.textContent);
        alert("Code: " + copyCode.textContent + " copied to the clipboard!");
      });
    }
  }
});